<div
  #toastElement
  class="toast fade toast-width mt-2"
  [ngClass]="type"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  <div class="toast-header">
    <strong class="me-auto">{{ title }}</strong>
    <button type="button" class="close" aria-label="Close" data-dismiss="toast" (click)="hide()">
        <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="toast-body">{{ message }}</div>
</div>